module.exports = "<template class=\"sortable\">\r\n    <slot></slot>\r\n    <i class=\"ml-1 fas ${iconClass}\"></i>\r\n</template>\r\n";